import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) {
      toast.success("Welcome back");
      const to = loc.state?.from || "/account";
      nav(to);
    } else {
      toast.error(r.error);
    }
  };

  return (
    <div className="min-h-screen pt-32 pb-24 flex items-start justify-center px-6" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#C85A32] mb-4">Account</div>
        <h1 className="font-serif-display text-5xl font-light mb-8">Welcome back.</h1>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Email">
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-transparent border border-[#EBE3D5] px-4 py-3 focus:border-[#1C3326] focus:outline-none"
            />
          </Field>
          <Field label="Password">
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-transparent border border-[#EBE3D5] px-4 py-3 focus:border-[#1C3326] focus:outline-none"
            />
          </Field>
          <button
            type="submit"
            disabled={busy}
            data-testid="login-submit"
            className="w-full bg-[#1C3326] hover:bg-[#15261C] text-[#FDFBF7] py-4 uppercase text-xs tracking-[0.3em] font-medium transition-colors disabled:opacity-60"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="mt-6 text-sm text-[#7B6F66]">
          No account?{" "}
          <Link to="/register" className="link-underline text-[#1C3326]" data-testid="link-register">
            Create one
          </Link>
        </p>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <label className="block">
      <div className="text-xs uppercase tracking-[0.15em] text-[#7B6F66] mb-2">{label}</div>
      {children}
    </label>
  );
}
